@if (reportSummaryPayload) {
<div class="content-container my-3">
  <div class="title">
    <mwp-text-translate text="Process Report" jsonKey="processReport" />
  </div>
  <div class="content">
    @for (summaryParameter of reportSummaryPayload.summaryParameters; track summaryParameter) {
    <div>
      <div>
        <label class="fw-bold label-alt mb-1">{{summaryParameter.caption}}</label>
      </div>
      <div class="mb-4">
        {{summaryParameter.value}}
      </div>
    </div>
    }
    <div class="mb-3">
      <label class="label-alt mb-1">
        <mwp-text-translate text="File Name" jsonKey="fileName" />
      </label>
      <div>
        {{reportSummaryPayload.fileName}}
      </div>
    </div>
    <div class="mb-3">
      <label class="label-alt mb-1">
        <mwp-text-translate text="File Type" jsonKey="fileType" />
      </label>
      <div>
        {{reportSummaryPayload.fileType}}
      </div>
    </div>
    @if (reportSummaryPayload.saveAsTemplate) {
    <div class="mb-3 col-4">
      <div class="note">
        <mwp-text-translate text="Your selected options will be saved as a template." jsonKey="reportBuilderSummaryNote" />
      </div>
      <div class="mb-3">
        <label class="label-alt mb-1">
          <mwp-text-translate text="Template Name" jsonKey="templateName" />
        </label>
        <div>
          {{reportSummaryPayload.templateName}}
        </div>
      </div>
      <div>
        <label class="label-alt mb-1">
          <mwp-text-translate text="Template Description" jsonKey="templateDescription" />
        </label>
        <div>
          {{reportSummaryPayload.templateDescription}}
        </div>
      </div>
    </div>
    }
    @if (reportSummaryPayload.sendEmailOnFinish) {
    <div class="note mb-3 col-4">
      <mwp-text-translate text="You will be notified by email when this report is due." jsonKey="reportBuilderSummaryNote2" />
    </div>
    }
  </div>
  <div class="footer d-inline-flex justify-content-end w-100">
    <button class="mwp-button-secondary" (click)="cancel()">
      <mwp-text-translate text="Cancel" jsonKey="cancel" />
    </button>
    <button class="mwp-button-save ms-3" (click)="save()">
      <mwp-text-translate text="Process" jsonKey="process" />
    </button>
  </div>
</div>
}